import { useContext, useEffect } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import { useFCTelemetryHandler } from '@/hooks/mavlinkTelemetryHandlers';
import { useAddressSelector } from '@/hooks/useMavLinkAddress';
import useMavLinkCommandHandler from '@/hooks/useMavLinkCommandHandler';
import usePingListener from '@/hooks/usePingListener';
import useWaitingRobot from '@/hooks/useWaitingRobot';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';

const useOrganizer = (robot) => {
  const address = useAddressSelector(robot.id);
  const { publishCommand } = useContext(MessageContext);

  usePingListener(robot.id);
  useWaitingRobotTimer(robot.id);
  const isWaiting = useWaitingRobot(robot.id);

  useFCTelemetryHandler(robot);
  const { addInterval, clearIntervals } = useMavLinkCommandHandler(robot);

  useEffect(() => {
    if (!robot.isActive) return;
    if (!address) return;
    if (isWaiting) return;

    if (robot.isOwned) {
      publishCommand(robot, 'request/autopilot_version', [[...address]]);
    }

    // prettier-ignore
    // eslint-disable-next-line no-lone-blocks
    {
      addInterval('request/data_stream', [[...address, 1, 2, 1]], 3000); // MAV_DATA_STREAM_RAW_SENSORS
      addInterval('request/data_stream', [[...address, 2, 2, 1]], 3000); // MAV_DATA_STREAM_EXTENDED_STATUS
      addInterval('request/data_stream', [[...address, 3, 2, 1]], 3000); // MAV_DATA_STREAM_RC_CHANNELS
      addInterval('request/data_stream', [[...address, 6, 3, 1]], 3000); // MAV_DATA_STREAM_POSITION
      addInterval('request/data_stream', [[...address, 10, 5, 1]], 3000); // MAV_DATA_STREAM_EXTRA1
      addInterval('request/data_stream', [[...address, 11, 5, 1]], 3000); // MAV_DATA_STREAM_EXTRA2
      addInterval('request/data_stream', [[...address, 12, 3, 1]], 3000); // MAV_DATA_STREAM_EXTRA3
      addInterval('request/heartbeat', [[]], 1000);
      addInterval('request/message_interval', [[...address, 242, 1000000]], 11000); // HOME_POSITION
    }

    return () => {
      clearIntervals();
    };
  }, [robot.isActive, isWaiting, address?.[0], address?.[1]]);
};

export default useOrganizer;
